import { AsyncTaskState } from 'library/async';

export const CLIENT_ID = 'demo-plq';
export const routes = {
  landingPage: '/quotes',
  login: '/',
  unauthorized: '/unauthorized',
  logout: '/logout',
  createQuote: '/quotes/new',
  viewQuote: '/quotes/:id',
  listQuotes: '/quotes',
};

export const saveStateStrings = {
  [AsyncTaskState.ERRORED]: 'Save',
  [AsyncTaskState.NOT_STARTED]: 'Save',
  [AsyncTaskState.COMPLETED]: 'Save',
  [AsyncTaskState.IN_PROGRESS]: 'Saving...',
};

export const loadTableStrings = {
  [AsyncTaskState.ERRORED]: 'Unable to load records',
  [AsyncTaskState.NOT_STARTED]: 'Preparing to load...',
  [AsyncTaskState.COMPLETED]: 'No results found', // meant to display this option only if there are 0 results
  [AsyncTaskState.IN_PROGRESS]: 'Loading records...',
};
